<template>
  <article v-if="sections" class="st-article">
    <section :class="section.class" v-for="(section, i) in sections" :key="i">
      <div v-for="(comp,count) in filterComponents(section.components)" :key="comp.type+'+'+count"
        :class="componentClass(comp)" :style="componentStyle(comp)">
          <div :class="componentContentClass(comp)" :style="componentContentStyle(comp)">
            <component :is="comp.type.toLowerCase()" :attributes="comp"></component>
          </div>
        </div>
    </section>
    <st-credits v-if="credits" :credits="credits" :lang="lang"></st-credits>
    <st-related v-if="relatedarticles" :relatedarticles="relatedarticles"></st-related>

    <section v-if="fbcomment" class="content-fb-comments">
      <div class="fb-comments" :data-href="url()" data-width="100%" data-numposts="5" data-colorscheme="light"></div>
    </section>
    <event-pop-up />
  </article>
</template>

<script>
import {mapState} from 'vuex'

import StCredits from './st-credits.vue'
import StRelated from './st-related.vue'
import EventPopUp from '../artefacts/project/eventpopup.vue'
import artefactsMixin from '../artefacts/mixin'

export default {
  computed: mapState(['sections', 'relatedarticles', 'credits', 'fbcomment', 'lang']),
  components: {StCredits, StRelated, EventPopUp},
  mixins: [artefactsMixin],
  methods: {
    filterComponents (components) {
      return components.filter(comp => this.existComponent(comp.type))
    },
    componentStyle (comp) {
      return {
        backgroundColor: comp.bg
      }
    },
    componentClass (comp) {
      return ['component', 'component-' + comp.type]
    },
    componentContentStyle (comp) {
      return {
        textAlign: comp.textalign
      }
    },
    componentContentClass (comp) {
      const defaultAlign = {
        [comp.type]: 'inline',
        paragraph: 'inline',
        subtitle: 'inline',
        quote: 'inline',
        tweet: 'inline',
        fbpost: 'inline',
        pullout: 'inline',
        bullets: 'inline',
        photo: 'spread',
        videocontent: 'spread',
        svgfolder: 'container',
        photogrid: 'container',
        scrolly: 'container',
        iframeresize: 'container'
      }

      const align = comp.align || comp.value.align || defaultAlign[comp.type]
      return {
        'component-content': true,
        [align]: align,
        [comp.class]: comp.class
      }
    },
    url () {
      return window.location.href.replace(/\?.+$/, '')
    }
  }
}
</script>

<style lang="scss">
.component {
  padding-top: 20px;
  padding-bottom: 20px;

  .component-content {
    padding: 0 $outerSpacing;
  }

  &.component-photo,
  &.component-svgfolder,
  &.component-scrolly,
  &.component-videocontent {
    .component-content {
      padding: 0;
    }
  }
}

article > section {
  padding: 0 0 20px;

  &:first-child {
    .component:first-child {
      padding-top: 35px;

      @include breakpoint($d_medium) {
        padding-top: 30px;
      }
    }
  }

  .component {
    &:first-child {
      padding-top: 20px;
    }

    &:last-child {
      padding-bottom: 20px;
    }

    .component-content {
      &.spread {
        @include spread_align;

        @include breakpoint($d_medium) {
          padding: 0 10px;
        }
      }

      &.inline {
        @include inline_align;
      }

      &.fullwidth {
        @include fullwidth_align;

        @include breakpoint($d_medium) {
          padding: 0;
        }
      }

      &.container {
        @include container_align;
      }

      &.immersive {
        padding: 0;
      }
    }
  }
}
</style>
